import { Container } from "./styles";
import React, { useLayoutEffect } from "react";
import FullscreenImageContainer from "#app/components/UI/FullscreenImageContainer";

const GridContainer = ({ children, ...props }: { [x: string]: any; children: any }): any => {
    useLayoutEffect((): (() => void) => {
        onResize();

        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);

    const onResize: (e?: any) => void = (): void => {
        let element: HTMLElement | null = document.getElementById("grid-container");

        if (element) {
            let parentHeight: number = window.innerHeight;

            let diff: string = parentHeight - 90 + "px";

            element.style.height = diff;
            element.style.maxHeight = diff;
        }
    };

    return (
        <Container id="grid-container" {...props}>
            <FullscreenImageContainer />
            {children}
        </Container>
    );
};

export default GridContainer;
